import { gql } from '@apollo/client';
import { useQueryWithSimpleErrorHandling } from 'hooks';

export const PARAM_QUERY = gql`
  query param($paramCode: String!) {
    param(paramCode: $paramCode)
  }
`;

export function useParams(paramCode, variableSetter) {
  const { data: paramData } = useQueryWithSimpleErrorHandling(PARAM_QUERY, {
    variables: { paramCode: paramCode },
    skip: !paramCode
  });

  const param = paramData?.param;

  if (variableSetter) variableSetter(param);

  return param;
}
